var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"direction":"vertical","id":"app"}},[_c('app-header'),_c('el-main',[_c('router-view'),_c('app-pwa-installer'),_c('el-backtop',{attrs:{"target":".el-main"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }